import Header from '../modules/header';
import FluidVid from '../modules/fluidvid';
import Social from '../modules/social';
import Doughnut from '../modules/doughnut';
import Utils from '../utils';

const Barba = require('barba.js');


const Excuse = Barba.BaseView.extend({
    namespace: 'excuse',

    onEnter() {
        this.header = new Header();
        this.header.enterExcuseState();

        new Social();
        new FluidVid();
    },

    onEnterCompleted() {
        if (Utils.isMobile()) {
            try {
                new Doughnut();
            } catch (err) {
                console.log(`Doughnut: ${err}`);
            }
        }
    },

    onLeave() {
        this.header.leaveExcuseState();
    },
});

export { Excuse as default };



// WEBPACK FOOTER //
// ./frontend/js/views/excuse.js